import { UPDATE_CACHE } from '.';

export function updateCache({ name, value }) {
  return {
    type: UPDATE_CACHE,
    payload: { name, value }
  };
}